import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ManagementApiService } from '../../../../../services';
import { CustomToastService } from '../../../../../services/custom-toast.service';
import { ConfirmationDialogComponent } from 'src/app/shared/info-dialogs/confirmation-dialog/confirmation-dialog.component';
import { ViewDto } from '../../../models/instance/instance.model';

@Component({
    selector: 'app-hierarchy-view-edit',
    templateUrl: './hierarchy-view-edit.component.html',
    styleUrls: ['./hierarchy-view-edit.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class HierarchyViewEditComponent implements OnInit {
    Name: any;
    idmsView: any;
    View: any;
    idmsHierarchy: any;
    viewUpdateFrm: any;
    instanceId: any;
    constructor(
        private formBuilder: UntypedFormBuilder,
        private modalService: NgbModal,
        private ngbActiveModal: NgbActiveModal
    ) {}

    ngOnInit(): void {
        this.getViewData(this.View);
    }

    getViewData(editIdmsView: any) {
        this.viewUpdateFrm = this.formBuilder.group({
            Name: new UntypedFormControl(editIdmsView.name, [Validators.required, Validators.max(255)]),
            IsDefault: new UntypedFormControl(editIdmsView.isDefault),
            IsDocument: new UntypedFormControl(editIdmsView.isDocument),
            Ordinal: new UntypedFormControl(editIdmsView.ordinal),
        });
    }

    IsDefaultChecked(event: any) {
        let IsDefault = false;

        if (event.checked) {
            let MultipleIsDefault = false;
            this.idmsView.forEach((Obj) => {
                if (Obj.ordinal != this.viewUpdateFrm.controls.Ordinal.value && Obj.isDefault == true) {
                    MultipleIsDefault = true;
                }
            });
            if (MultipleIsDefault) {
                let dialogRef = this.modalService.open(ConfirmationDialogComponent, {
                    size: 'sm',
                });
                dialogRef.componentInstance.modalMessage = 'Are you sure you want to set this view as default?';
                dialogRef.result.then((result) => {
                    if (result === true) {
                        IsDefault = result;
                    } else {
                        IsDefault = false;
                    }
                    this.viewUpdateFrm = this.formBuilder.group({
                        Name: new UntypedFormControl(this.viewUpdateFrm.controls.Name.value, [Validators.required, Validators.max(255)]),
                        IsDefault: new UntypedFormControl(IsDefault),
                        IsDocument: new UntypedFormControl(IsDefault ? false : this.viewUpdateFrm.controls.IsDocument.value),
                        Ordinal: new UntypedFormControl(this.viewUpdateFrm.controls.Ordinal.value),
                    });
                });
            }
        } else {
            this.viewUpdateFrm = this.formBuilder.group({
                Name: new UntypedFormControl(this.viewUpdateFrm.controls.Name.value, [Validators.required, Validators.max(255)]),
                IsDefault: new UntypedFormControl(event.checked),
                IsDocument: new UntypedFormControl(event.checked ? false : this.viewUpdateFrm.controls.IsDocument.value),
                Ordinal: new UntypedFormControl(this.viewUpdateFrm.controls.Ordinal.value),
            });
        }
    }

    IsDocumentChecked(event: any) {
        this.viewUpdateFrm = this.formBuilder.group({
            Name: new UntypedFormControl(this.viewUpdateFrm.controls.Name.value, [Validators.required, Validators.max(255)]),
            IsDefault: new UntypedFormControl(event.checked ? false : this.viewUpdateFrm.controls.IsDocument.value),
            IsDocument: new UntypedFormControl(event.checked),
            Ordinal: new UntypedFormControl(this.viewUpdateFrm.controls.Ordinal.value),
        });
    }

    saveIdmsViewData() {
        let ViewData: ViewDto = new ViewDto();

        ViewData.Name = this.viewUpdateFrm.controls.Name.value;
        ViewData.Ordinal = this.viewUpdateFrm.controls.Ordinal.value;
        ViewData.IsDefault = this.viewUpdateFrm.controls.IsDefault.value;
        ViewData.IsDocument = this.viewUpdateFrm.controls.IsDocument.value;
        this.View = ViewData;
        this.ngbActiveModal.close(ViewData);
    }

    closeModal() {
        this.modalService.dismissAll();
    }

    detectValueChanges() {}
}
